import { App, Form } from 'antd';
import { useEffect, useState } from 'react';

import { consumersActions } from '@store/consumers/consumers.slice';

import { useCurrentApplication } from '@hook/application/use-current-application.hook';
import { useMutation } from '@hook/common/use-mutation.hook';
import { useAddConsumerMutation } from '@hook/consumer/consumer.hooks';
import { useMemberRole } from '@hook/memeber/use-member-role.hook';
import { useStoreSelector } from '@hook/store/store.hooks';
import { AddConsumerInterface } from '@interface/consumer/consumer.interface';

export const useNewConsumer = () => {
  const { current } = useCurrentApplication();
  const { action, state } = useMutation(useAddConsumerMutation(), consumersActions, consumersActions.setConsumer);
  const isLoading = useStoreSelector((state) => state.consumers.isLoading);
  const [isModalOpen, setModalOpen] = useState(false);
  const { message } = App.useApp();
  const [form] = Form.useForm<AddConsumerInterface>();
  const { isViewer } = useMemberRole();

  const onFinish = (values: AddConsumerInterface) =>
    action({ ...values, application: current.id } as AddConsumerInterface);

  const onOpenModal = () => !isViewer && setModalOpen(true);
  const onCloseModal = () => {
    setModalOpen(false);
    form.resetFields();
  };

  useEffect(() => {
    if (state.isSuccess && isModalOpen) {
      message.success('Consumer was successfully added');
      setModalOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.isSuccess, message]);

  return {
    form,
    isLoading,
    isModalOpen,
    onFinish,
    onOpenModal,
    onCloseModal,
    shouldEdit: !isViewer,
  };
};
